

function CustomButton({ onClick, text, isEditEnabled, isDeleteEnabled, isDisabled, text2,variant = "default", profileEdit = false  }) {
  const isButtonDisabled = 
    text === "Edit" ? !isEditEnabled : 
    text === "Delete" ? !isDeleteEnabled : 
    isDisabled;

  // Base Bootstrap class is 'btn', then add specific variant classes
  const buttonClass = 
    `btn ${
      text === "Delete" ? "btn-danger" :
      text ==="Delete Permanently"?"btn-danger":
      // text === "Edit" ? "btn-edit" :
       text === "Edit" ? (profileEdit ? "btn-primary" : "btn-edit") : // Modified this line
      text === "Restore" ? "btn-primary" :
      text==="Save Changes"?"btn-primary":
      text === "Cancel" ? "btn-edit":
      text==="Remove Avatar"?"btn-edit":
      "btn-primary"
    } custom-button`;  // Add your custom class at the end
  
  const iconClass = 
    text === "Delete" ? "fa-trash-alt" :
    text === "Delete Permanently" ? "fa-trash-alt" :
    text === "Edit" ? "fa-edit" :
    text ==="Save Changes"?"fa-solid fa-floppy-disk":
    text === "Restore" ? "fa-undo" :  // Optional: you can remove this if you don't want icon for restore
    text === "Cancel" ? "fa-times" :  // No icon for cancel
    text==="Upload Avatar"?"fa-cloud-upload-alt":
    text==="Change Avatar"?"fas fa-camera":
    text==="Remove Avatar"?"fas fa-trash":
    "fa-plus";

  return (
    <button
      onClick={onClick}
      disabled={isButtonDisabled}
      className={buttonClass}
    >
      {iconClass && <i className={`font-size-sm-10 fas ${iconClass}`}></i>}
      <span className="d-sm-none d-none d-md-block d-lg-block d-xl-block ms-1">{text}</span>
      {text2 && <span className="d-sm-block d-md-none font-size-sm-10 d-lg-none d-xl-none ms-1">{text2}</span>}
    </button>
  );
}

export default CustomButton;